const fmtRp = (n) => new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(n);

const GARIS = "────────────────────";

export function summaryRefund(t, { nama, harga, total, sisa, rate, hasil }) {
    return [
        `Refundaja — ${t.r3}`,
        nama ? `${t.f1}: ${nama}` : null,
        `${t.f2}: Rp ${fmtRp(harga)}`,
        `${t.f4}: ${total} · ${t.f3}: ${sisa}`,
        `${t.f5}: ${Math.round(rate * 100)}%`,
        GARIS,
        `${t.r1}: Rp ${fmtRp(hasil)}`,
        window.location.origin,
    ]
        .filter(Boolean)
        .join("\n");
}

export function summarySisa(t, { startStr, endStr, totalHari, sisaHari, aktif }) {
    return [
        `Refundaja — ${t.t2}`,
        `${t.s11}: ${startStr}`,
        `${t.s12}: ${endStr}`,
        `${t.s3}: ${totalHari} ${t.s9 === "days elapsed" ? "days" : "hari"}`,
        GARIS,
        `${aktif ? t.s6 : t.s7} — ${sisaHari} ${t.s8}`,
        window.location.origin,
    ].join("\n");
}

export const IMG_LABEL = {
    id: "Unduh Gambar", en: "Download Image", jv: "Unduh Gambar", su: "Unduh Gambar",
    ms: "Muat Turun Imej", tl: "I-download ang Larawan", th: "ดาวน์โหลดรูปภาพ", vi: "Tải hình ảnh",
    zh: "下载图片", ja: "画像をダウンロード", ko: "이미지 다운로드", hi: "छवि डाउनलोड करें",
    bn: "ছবি ডাউনলোড", ur: "تصویر ڈاؤن لوڈ", ar: "تنزيل الصورة", tr: "Görseli İndir",
    ru: "Скачать картинку", es: "Descargar imagen", pt: "Baixar imagem", fr: "Télécharger l'image",
    de: "Bild herunterladen", nl: "Afbeelding downloaden", it: "Scarica immagine", sw: "Pakua Picha",
};

export function shareWhatsApp(text) {
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
}

export function shareTelegram(text) {
    window.open(
        `https://t.me/share/url?url=${encodeURIComponent(window.location.origin)}&text=${encodeURIComponent(text)}`,
        "_blank",
        "noopener"
    );
}

export async function copyText(text) {
    await navigator.clipboard.writeText(text);
}

export async function shareSite(text) {
    const data = { title: "Refundaja", text, url: window.location.origin };
    try {
        if (navigator.share) {
            await navigator.share(data);
            return "shared";
        }
        await navigator.clipboard.writeText(data.url);
        return "copied";
    } catch (e) {
        if (e && e.name === "AbortError") return null;
        try {
            await navigator.clipboard.writeText(data.url);
            return "copied";
        } catch {
            return null;
        }
    }
}
